module.exports = __webpack_public_path__ + "static/MailSculpt-Blog-1-a67812f1dbbed2e3c99fe1ec72d6cdfa.jpg";